import { getLangFallbackUrl } from '~/lang/utils/langfetch'
import { csrfTokenService } from '../csrf/CsrfTokenService'

export class ValidatePhoneNumberRepositoryFetch {
  async validate(
    dialingCode: string,
    phoneNumber: string,
    langCode: string,
  ): Promise<string> {
    return await this.getResponse(dialingCode, phoneNumber, langCode)
  }

  private getFormData(dialingCode: string, phoneNumber: string) {
    const formData = new FormData()
    formData.append('dialing_code', dialingCode)
    formData.append('phone_number', phoneNumber)
    return formData
  }

  private async getResponse(
    dialingCode: string,
    phoneNumber: string,
    langCode: string,
  ): Promise<string> {
    const { csrfToken } = await csrfTokenService()
    try {
      return await $fetch<string>(
        getLangFallbackUrl(langCode, '/_/endpoints/validate-phone-number/'),
        {
          method: 'POST',
          body: this.getFormData(dialingCode, phoneNumber),
          headers: {
            // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment -- TODO: csrfToken is untyped
            'X-CSRFToken': csrfToken,
          },
          timeout: 10000,
        },
      )
    } catch (error: unknown) {
      const fetchError = error as {
        status?: number
        data?: { errors?: unknown }
      }
      if (fetchError.status === 400) {
        throw fetchError.data?.errors
      }
      throw error
    }
  }
}
